import { render, staticRenderFns } from "./UserGeneralInfoUpdate.vue?vue&type=template&id=38fb2284&"
import script from "./UserGeneralInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./UserGeneralInfoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports